<template>
  <div class="section">
    <div class="container custom-container">
      <!-- Report -->
      <router-link :to="{name: 'result', params: { id: simulationId}}" class="button is-primary is-pulled-right">Return to Results</router-link>

      <!-- Title -->
      <h1 class="title">Report</h1>
      <h2 class="title is-4 simulation-title" v-if="inputs">{{ inputs.title }}</h2>

      <!-- GrapesJS -->
      <div id="gjs"></div>
      <div id="blocks"></div>

      <div class="buttons has-text-centered">
        <button v-on:click="saveReport" v-if="!loading" class="button is-primary">Save Report</button>
        <button v-on:click="resetReport" v-if="!loading" class="button is-primary">Reset</button>
        <button v-on:click="print" v-if="!loading" class="button is-primary">Print</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint
    'import/no-webpack-loader-syntax': 'off',
    'no-eval': 'off',
    'no-unused-vars': 'off',
*/
import config from '@/config/apollo-config';
import gql from 'graphql-tag';
import 'grapesjs/dist/css/grapes.min.css';
import 'grapesjs-preset-webpage/dist/grapesjs-preset-webpage.min.css';
import grapesjs from 'grapesjs';
// import presetWebpage from 'grapesjs-preset-webpage';
import headerEjs from 'ejs-loader!../assets/report/header.ejs';
import executiveSummaryEjs from 'ejs-loader!../assets/report/1-executive-summary.ejs';
import introductionEjs from 'ejs-loader!../assets/report/2-introduction.ejs';
import verificationEjs from 'ejs-loader!../assets/report/3-verification.ejs';
import systemConfigurationEjs from 'ejs-loader!../assets/report/4-system-configuration.ejs';
import governingEquationsEjs from 'ejs-loader!../assets/report/5-governing-equations.ejs';
import systemPropertiesEjs from 'ejs-loader!../assets/report/6-system-properties.ejs';
import systemConditionsEjs from 'ejs-loader!../assets/report/7-system-conditions.ejs';
import systemDiscretizationEjs from 'ejs-loader!../assets/report/8-system-discretization.ejs';
import numericalImplementationEjs from 'ejs-loader!../assets/report/9-numerical-implementation.ejs';
import resultsEjs from 'ejs-loader!../assets/report/10-results.ejs';
import referencesEjs from 'ejs-loader!../assets/report/11-references.ejs';
import footerEjs from 'ejs-loader!../assets/report/footer.ejs';
import styleCss from '!!raw-loader!../assets/report/style.css';
import apiCall from '../lib/remote-calls';

export default {
  name: 'report',
  data() {
    return {
      loading: true,
      editor: null,
      simulationId: null,
      inputs: null,
      outputs: null,
      images: null,
      report: null,
      templates: null,
    };
  },
  methods: {
    async requestData() {
      const response = await apiCall('GET', `simulations/${this.simulationId}`);
      this.inputs = response.data.indata;
      // console.debug('inputs', this.inputs);
      this.outputs = response.data.outdata;
      // console.debug('outputs', this.outputs);
    },
    async requestImageList() {
      const response = await apiCall('GET', `media/${this.simulationId}`);
      this.images = response.data;
      // console.debug('images', this.images);
    },
    async getReport() {
      let report = null;
      try {
        const response = await this.$apollo.query({
          query: gql`
          query getReports($product_name: ProductName!, $simulation_id: Int!) {
            reports: getReports(product_name: $product_name, simulation_id: $simulation_id) {
              oid
              product_name
              simulation_id
              created_at
              page
            }
          }`,
          variables: {
            product_name: config.productName,
            simulation_id: parseInt(this.simulationId, 10),
          },
        });
        const { reports } = response.data;
        // console.debug('reports', reports);
        if (reports != null && reports.length > 0) {
          [report] = reports;
          this.report = report;
        }
      } catch (error) {
        console.error(error);
      }
      return report;
    },
    async postReport(page) {
      const response = await this.$apollo.mutate({
        mutation: gql`
        mutation addReport($product_name: ProductName!, $simulation_id: Int!, $page: String!) {
          result: addReport(product_name: $product_name, simulation_id: $simulation_id, page: $page)
        }`,
        variables: {
          product_name: config.productName,
          simulation_id: parseInt(this.simulationId, 10),
          page,
        },
        // TODO update apollo cache
      });
      // const { result } = response.data;
      // console.debug('result', result);
    },
    saveReport() {
      try {
        const page = this.editor.getHtml();
        // console.debug('page', page);
        this.postReport(page);
        this.$utils.alertMessage('Report saved successfully');
      } catch (error) {
        this.$utils.alertError(error);
      }
    },
    resetReport() {
      try {
        this.editor.setComponents(this.templates);
        this.parseEditorComponents();
        this.$utils.alertMessage('Report reset completed successfully');
      } catch (error) {
        this.$utils.alertError(error);
      }
    },
    print() {
      // We want to hide the "Add text (optional)" default input when printing.
      // When we use .flex-editable:empty::before { content: "Add text (optional)"}
      // CSS selector to get the element, grapesjs changes it to box instead of text,
      // which messes up the editor. So doing via Javascript instead.
      const report = window.frames[1];
      const grapesInputs = report.document.getElementsByClassName('flex-editable');
      for (let index = 0; index < grapesInputs.length; index += 1) {
        const element = grapesInputs[index];
        if (element.textContent === 'Add text (optional)') {
          element.classList.add('hide-for-print');
        } else {
          element.classList.remove('hide-for-print');
        }
      }
      report.print();
    },
    // https://developer.mozilla.org/it/docs/Web/JavaScript/Reference/Global_Objects/eval#Accessing_member_properties
    extractValueFromIO(key, inputs = this.inputs, outputs = this.outputs, images = this.images) {
      // console.debug(`key = ${key}`);
      let value = null;
      try {
        value = eval(key);
      } catch (error) {
        // console.debug(error);
      }
      // console.debug(`value = ${value}`);
      return value;
    },
    // Decoration of I/O data
    decorationData(inputs = this.inputs, outputs = this.outputs, images = this.images) {
      // inputs.SimSetup.AnsysVersion
      inputs.SimSetup.AnsysVersion = '2019 R3';

      let ssFrequencyTesla = 0;
      let authorPublication = '';
      let authorSystem = '';
      let coilDiameter = 0;
      let coilLength = 0;
      let shieldDiameter = 0;
      let shieldLength = 0;
      const ssFrequency = this.extractValueFromIO('inputs.SimSetup.Frequency');
      if (ssFrequency === 64) {
        ssFrequencyTesla = 1.5;
        authorPublication = 'Kozlov et al. (2016)';
        authorSystem = 'Lucano et al.';
        coilDiameter = 420;
        coilLength = 650;
        shieldDiameter = 630;
        shieldLength = 800;
      } else if (ssFrequency === 128) {
        ssFrequencyTesla = 3;
        authorPublication = 'Serano et al. (2015)';
        authorSystem = 'Bonmassar et al.';
        coilDiameter = 610;
        coilLength = 670;
        shieldDiameter = 657;
        shieldLength = 900;
      }
      inputs.SimSetup.Frequency_Tesla = ssFrequencyTesla;
      inputs.Author = {};
      inputs.Author.Publication = authorPublication;
      inputs.Author.System = authorSystem;
      inputs.Coil = {};
      inputs.Coil.Diameter = coilDiameter;
      inputs.Coil.Length = coilLength;
      inputs.Shield = {};
      inputs.Shield.Diameter = shieldDiameter;
      inputs.Shield.Length = shieldLength;

      // inputs.SimSetup.PolarizationString
      const ssPolarization = this.extractValueFromIO('inputs.SimSetup.Polarization');
      let ssPolarizationString = '';
      if (ssPolarization === 'CP1') {
        ssPolarizationString = 'circularly polarized';
      } else if (ssPolarization === 'CP2') {
        ssPolarizationString = 'circularly polarized';
      } else if (ssPolarization === 'LP1') {
        ssPolarizationString = 'linearly polarized';
      } else if (ssPolarization === 'LP2') {
        ssPolarizationString = 'linearly polarized';
      }
      inputs.SimSetup.PolarizationString = ssPolarizationString;

      // inputs.SimSetup.SinusoidalSignal
      const ssPower = this.extractValueFromIO('inputs.SimSetup.Power');
      let ssSinusoidalSignal = '';
      if (ssFrequency === 64) {
        if (ssPower === 2) {
          if (ssPolarization === 'CP1') {
            ssSinusoidalSignal = 172.6;
          } else if (ssPolarization === 'CP2') {
            ssSinusoidalSignal = 172.6;
          } else if (ssPolarization === 'LP1') {
            ssSinusoidalSignal = 245;
          } else if (ssPolarization === 'LP2') {
            ssSinusoidalSignal = 245;
          }
        } else if (ssPower === 4) {
          if (ssPolarization === 'CP1') {
            ssSinusoidalSignal = 246;
          } else if (ssPolarization === 'CP2') {
            ssSinusoidalSignal = 143;
          } else if (ssPolarization === 'LP1') {
            ssSinusoidalSignal = 343;
          } else if (ssPolarization === 'LP2') {
            ssSinusoidalSignal = 344;
          }
        } else if (ssPower === 10) {
          if (ssPolarization === 'CP1') {
            ssSinusoidalSignal = 386.2;
          } else if (ssPolarization === 'CP2') {
            ssSinusoidalSignal = 384;
          } else if (ssPolarization === 'LP1') {
            ssSinusoidalSignal = 543;
          } else if (ssPolarization === 'LP2') {
            ssSinusoidalSignal = 546;
          }
        }
      } else if (ssFrequency === 128) {
        if (ssPower === 2) {
          if (ssPolarization === 'CP1') {
            ssSinusoidalSignal = 129;
          } else if (ssPolarization === 'CP2') {
            ssSinusoidalSignal = 119.5;
          } else if (ssPolarization === 'LP1') {
            ssSinusoidalSignal = 183;
          } else if (ssPolarization === 'LP2') {
            ssSinusoidalSignal = 183;
          }
        } else if (ssPower === 4) {
          if (ssPolarization === 'CP1') {
            ssSinusoidalSignal = 182;
          } else if (ssPolarization === 'CP2') {
            ssSinusoidalSignal = 168;
          } else if (ssPolarization === 'LP1') {
            ssSinusoidalSignal = 256;
          } else if (ssPolarization === 'LP2') {
            ssSinusoidalSignal = 256;
          }
        } else if (ssPower === 10) {
          if (ssPolarization === 'CP1') {
            ssSinusoidalSignal = 287;
          } else if (ssPolarization === 'CP2') {
            ssSinusoidalSignal = 265;
          } else if (ssPolarization === 'LP1') {
            ssSinusoidalSignal = 401.5;
          } else if (ssPolarization === 'LP2') {
            ssSinusoidalSignal = 401.5;
          }
        }
      }
      inputs.SimSetup.SinusoidalSignal = ssSinusoidalSignal;

      // inputs.SimSetup.TDuration_Min
      const ssTDuration = parseInt(this.extractValueFromIO('inputs.SimSetup.TDuration'), 10);
      let ssTDurationMin = 0;
      if (ssTDuration > 0) {
        ssTDurationMin = Math.floor(ssTDuration / 60);
      }
      inputs.SimSetup.TDuration_Min = ssTDurationMin;

      // inputs.GenericDevices
      const implantName = this.extractValueFromIO('inputs.Implant.Name');
      const stentNumber = this.extractValueFromIO('inputs.Stent.Number');
      const stentInsulation1T = this.extractValueFromIO('inputs.Stent.Insulation1_T');
      const stentInsulation2T = this.extractValueFromIO('inputs.Stent.Insulation2_T');
      const rodInsulationT = this.extractValueFromIO('inputs.Rod.Insulation_T');
      const rodTip1L = this.extractValueFromIO('inputs.Rod.Tip1_L');
      const rodTip2L = this.extractValueFromIO('inputs.Rod.Tip2_L');
      let genericDevices = '';
      if (implantName != null && implantName === 'Stent') {
        if (stentNumber != null && stentNumber === 1) {
          if (stentInsulation1T == null) {
            genericDevices = 'one hollow rod, mimicking a simplified stent';
          } else {
            genericDevices = 'one covered hollow rod, mimicking a simplified stent';
          }
        } else if (stentNumber != null && stentNumber === 2) {
          if (stentInsulation1T == null && stentInsulation2T == null) {
            genericDevices = 'two hollow rods, mimicking a simplified stent';
          } else if (stentInsulation1T != null && stentInsulation2T != null) {
            genericDevices = 'two covered hollow rods, mimicking a simplified stent';
          } else {
            genericDevices = 'two hollow rods witch one of the two was covered, mimicking a simplified stent';
          }
        }
      } else if (implantName != null && implantName === 'Rod') {
        if (rodInsulationT == null) {
          genericDevices = 'a rod, mimicking a simplified catheter';
        } else if (rodTip1L == null && rodTip2L == null) {
          genericDevices = 'a covered rod, mimicking a simplified catheter';
        } else if (rodTip1L != null && rodTip2L != null) {
          genericDevices = 'a covered rod with two bare tips, mimicking a simplified catheter';
        } else {
          genericDevices = 'a covered rod with one bare tip, mimicking a simplified catheter';
        }
      }
      inputs.GenericDevices = genericDevices;

      // inputs.RefRod.NameString
      const rrName = this.extractValueFromIO('inputs.RefRod.Name');
      if (rrName != null) {
        let rrNameString = '';
        if (rrName === 'HollowRod') {
          rrNameString = 'Hollow Rod';
        } else if (rrName === 'Rod') {
          rrNameString = 'Rod';
        }
        inputs.RefRod.NameString = rrNameString;
      }

      // inputs.Probes.Size
      const probes = this.extractValueFromIO('inputs.Probes');
      if (probes != null) {
        const probesSize = probes.length;
        inputs.Probes.Size = probesSize;
      }

      // outputs.Emag_background.perc
      const emagBackgroundMean = this.extractValueFromIO('outputs.Emag_background.mean');
      const emagBackgroundStd = this.extractValueFromIO('outputs.Emag_background.std');
      if (emagBackgroundMean != null && emagBackgroundStd != null) {
        const emagBackgroundPerc = (emagBackgroundStd * 100) / emagBackgroundMean;
        outputs.Emag_background.perc = emagBackgroundPerc;
      }
    },
    parseEditorComponents() {
      // Get all components - https://github.com/artf/grapesjs/issues/789
      const getAllComponents = (model, result = []) => {
        result.push(model);
        model.components().each((mod) => getAllComponents(mod, result));
        return result;
      };
      const all = getAllComponents(this.editor.DomComponents.getWrapper());

      // https://grapesjs.com/docs/api/component.html
      all.forEach((component) => {
        const attributes = component.get('attributes');

        const { field } = attributes;
        if (field) {
          const value = this.extractValueFromIO(field);
          if (value) {
            // Check component's type
            if (component.is('image')) {
              component.set('src', value);
            } else {
              component.set('content', value);
            }
          }
        }

        // Disabling components without class 'flex-editable' or 'header-editable'
        const classes = component.getClasses();
        const isFlexEditable = classes.includes('flex-editable');
        const isHeaderEditable = classes.includes('header-editable');
        if (!(isFlexEditable || isHeaderEditable)) {
          component.set({
            draggable: false,
            droppable: false,
            copyable: false,
            removable: false,
            editable: false,
            selectable: false,
            hoverable: false,
          });
        }
      });
    },
    clearGrapesjsVarsFromLocalStorage() {
      localStorage.removeItem('gjs-assets');
      localStorage.removeItem('gjs-components');
      localStorage.removeItem('gjs-css');
      localStorage.removeItem('gjs-html');
      localStorage.removeItem('gjs-styles');
    },
  },
  async mounted() {
    try {
      this.simulationId = this.$route.params.id;

      // Request I/O data
      let data = this.requestData();
      // Request Image List
      let imageList = this.requestImageList();
      // Request Report from DB
      let report = this.getReport();
      // Call async/await functions in parallel
      [data, imageList, report] = [await data, await imageList, await report];

      // Decoration I/O data and Image List
      this.decorationData();

      // Load templates
      const normalPrecision = (value) => Number.parseFloat(value).toFixed(3);
      const vars = {
        inputs: this.inputs, outputs: this.outputs, images: this.images, normalPrecision,
      };
      this.templates = [headerEjs(), executiveSummaryEjs(vars), introductionEjs(vars), verificationEjs(vars), systemConfigurationEjs(vars), governingEquationsEjs(vars), systemPropertiesEjs(vars), systemConditionsEjs(vars), systemDiscretizationEjs(vars), numericalImplementationEjs(vars), resultsEjs(vars), referencesEjs(vars), footerEjs()];

      let pageHtml;
      if (this.report != null && this.report.page != null) {
        // Html from report (database)
        pageHtml = this.report.page;
      } else {
        // Html from templates
        pageHtml = this.templates;
      }

      this.loading = false;

      // Clear Grapesjs vars from localStorage for safety
      this.clearGrapesjsVarsFromLocalStorage();

      // Definition of the editor's interface - https://grapesjs.com/docs/getting-started.html#start-from-the-canvas
      this.editor = grapesjs.init({
        // Indicate where to init the editor. You can also pass an HTMLElement
        container: '#gjs',

        // third-party library - https://grapesjs.com/docs/modules/Components-js.html#dependencies
        canvas: {
          scripts: [
            // MathJax - http://asciimath.org/
            'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-MML-AM_CHTML',
          ],
        },

        // Plugins setting
        // https://github.com/artf/grapesjs-preset-webpage
        /* plugins: ['gjs-preset-webpage'],
        pluginsOpts: {
          'gjs-preset-webpage': {
            // options
          }
        }, */

        // The `components` accepts HTML string or a JSON of components, the `style` accepts Style or CSS
        components: pageHtml,
        style: styleCss,

        // Size of the editor
        height: '70vh',
        width: 'auto',

        // Storage Manager - https://grapesjs.com/docs/modules/Storage.html
        /*
        storageManager: {
          id: "gjs-",
          type: "local",
          // As we already initialize the editor with the template we can skip the `autoload`
          autoload: false,
          autosave: true
        },
        */
        // Disable the storage manager for the moment
        storageManager: false,

        // Avoid any default panel
        panels: { defaults: [] },
      });

      // Parse Editor Components
      this.parseEditorComponents();
    } catch (error) {
      this.$utils.alertError(error);
    }
  },
};
</script>

<style>
/* Let's highlight canvas boundaries */
#gjs {
  border: 1px solid gray;
  margin-bottom: 20px;
}

/* Reset some default styling */
.gjs-cv-canvas {
  top: 0;
  width: 100%;
  height: 100%;
}

.gjs-block {
  width: auto;
  height: auto;
  min-height: auto;
}
</style>
